<template>
	<div>
		<div class="" style="margin-left:-15px;margin-right:-15px">
			<!-- Teritory Management Start-->
			<div class="row">
				<div class="col-12 col-md-5 Aligner-Header" style="justify-content: flex-start; padding-top: 0; padding-bottom: 0;">
					<h3>Territory Management</h3>
					<h6>Choose 1 Dealer To Use This Feature</h6>
					
					
					
					<Multiselect 
						class="wrapHighlight mb-3 w-75"
						style="margin-top:20px"
						:options="['By Kecamatan' , 'By Dealer Radius' , 'By Dealer Range']"
						v-model="filter.territoryOptions.mapType"
					/>
					<div class="mt-auto mb-auto">
						<span class="h6" style="font-size:14px">Total {{type}} {{filter.territoryOptions.mapType}}</span>
						<div class="row">
							<div class="col-md text-center" v-for="(legend, index) in totalCount" :key="index">
								<span> <span class="h5">{{numberWithCommas(legend.count)}}</span>&nbsp;&nbsp;<span class="h6">{{legend.total ? Math.round(legend.count / legend.total * 100) : 0}}%</span></span>
								<h6>{{filter.territoryOptions.mapType == 'By Kecamatan' ? legend.desc : legend.text}}</h6>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-7" style="padding: 0 50px 0 10px;">
					<div class="row">
						<div class="offset-md-6 col-md-3" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px"
								type="button" 
								class="w-100 btn" 
								:class="(type == 'Sales') ? 'btn-primary' : 'btn-outline-primary'" 
								@click="type = 'Sales'"
							>
								Sales
							</button>
						</div>
						<div class="col-md-3" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px"
								type="button" 
								:disabled="type == 'Sales By Document'"
								class="w-100 btn" 
								:class="(type == 'Service') ? 'btn-primary' : 'btn-outline-primary'" 
								@click="type = 'Service'"
							>
								Service
							</button>
						</div>
					</div>
					<div class="row mt-3">
						<!-- <div class="col-12 col-md highlightFilter">
						<Multiselect
							class="mt-1 "
							:options="['Jawa Timur', 'NTT']"
							:searchable="true"
							:close-on-select="true"
							:show-labels="false"
							v-model="filter.territoryOptions.area"
							:placeholder="filter.territoryOptions.area"
						/>
						</div> -->
						<div class="col-12 offset-md-3 col-md-3 highlightFilter" >
						<Multiselect
							class="mt-1 wrapHighlight"
							:options="options.dealer"
							:searchable="true"
							:close-on-select="true"
							label="name"
							:show-labels="false"
							v-model="filter.territoryOptions.dealer"
							placeholder="Choose 1 Dealer"
						/>
						</div>
						<div class="col-12 col-md-3 highlightFilter" >
						<Multiselect
							class="mt-1 wrapHighlight"
							:options="options.type"
							:searchable="true"
							label="type"
							:close-on-select="true"
							:show-labels="false"
							v-model="filter.territoryOptions.type"
							placeholder="All Type"
						/>
						</div>
						<div class="col-12 col-md-3 highlightFilter">
						<Multiselect
							class="mt-1 wrapHighlight"
							:options="options.color"
							:searchable="true"
							label="name"
							:close-on-select="true"
							:show-labels="false"
							v-model="filter.territoryOptions.color"
							placeholder="All Color"
						/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md" :class="{'offset-md-4' : !toggleServiceDate}">
							<label>Filter By</label>
							<Multiselect
								class="w-100 wrapHighlight"
								:options="filterByMaster.map(x => x.variable)"
								:custom-label="opt => filterByMaster.find(x => x.variable == opt).name"
								:searchable="true"
								:close-on-select="true"
								:show-labels="false"
								v-model="filter.territoryOptions.filterBy"
							/>
						</div>
						<div class="col-12 col-md" :class="{'offset-md-4' : !toggleServiceDate}">
							<label>Range Options</label>
							<Multiselect
								class="w-100 wrapHighlight"
								:options="['Semester' , 'Quarterly', 'Monthly']"
								:searchable="true"
								:close-on-select="true"
								:show-labels="false"
								v-model="optionRangeTerritory"
							/>
						</div>
						<div class="col-12 col-md pr-3" v-if="type == 'Sales' || type == 'Sales By Document'">
							<div class="form-group m-0">
								<label>Sales Date</label>
								<date-range-picker 
									class="w-100 mr-4"
									v-model="territoryRange"
									style="min-height:43px"
									ref="picker"
									:opens="'left'"
									:ranges="rangeOption[optionRangeTerritory]"
									:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
								>
									<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
										<i class="fa fa-calendar fa-fw ml-n1"></i> 
										{{labelTerritory == '' ? '' : labelTerritory + ' -'}} {{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
										<b class="caret"></b>
									</template>
								</date-range-picker>
							</div>
						</div>
						<div class="col-12 col-md pr-3" v-if="toggleServiceDate">
							<div class="form-group m-0">
								<!-- {{toggleServiceDate}} -->
								<label>Service Date</label>
								<date-range-picker 
									class="w-100 mr-4"
									v-model="territoryRangeService"
									style="min-height:43px"
									ref="picker"
									:opens="'left'"
									:ranges="rangeOption[optionRangeTerritory]"
									:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
									
								>
									<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
										<i class="fa fa-calendar fa-fw ml-n1"></i> 
										{{labelTerritoryService == '' ? '' : labelTerritoryService + ' -'}} {{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
										<b class="caret"></b>
									</template>
								</date-range-picker>
							</div>
						</div>
						<div class="col-12 col-md pr-3" v-if="type == 'Service'">
							<div class="form-group m-0">
								<!-- {{toggleServiceDate}} -->
								<label>Service Date</label>
								<date-range-picker 
									class="w-100 mr-4"
									v-model="territoryRangeService2"
									style="min-height:43px"
									ref="picker"
									:opens="'left'"
									:ranges="rangeOption[optionRangeTerritory]"
									:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
									
								>
									<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
										<i class="fa fa-calendar fa-fw ml-n1"></i> 
										{{labelTerritoryService2 == '' ? '' : labelTerritoryService2 + ' -'}} {{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
										<b class="caret"></b>
									</template>
								</date-range-picker>
							</div>
						</div>
						<!-- <div class="col-12 col-md-4 pr-4">
							<button
								type="button"
								class="btn btn-warning w-100"
								style="height:70%"
								@click="exportExcel()"
							>Download CSV <i class="fas fa-download"></i></button>
						</div> -->
					</div>
				</div>
			</div>

			<div class="text-right mr-5 mt-4">
				<button class="btn btn-primary mr-4" @click="downloadSuggestRing">Suggest Ring</button>
				<button class="btn btn-primary mr-4" @click="downloadExcel">Download Excel <i class="fa fa-download"></i></button>
				<button class="btn btn-primary" @click="hitAPI">Submit Filter</button>
			</div>
			<!-- {{data && sendData}} -->
			<TerittoryManagement
				v-if="data.territory && sendData" 
				@changeDoc="changeDoc" 
				@showTotal="showTotal"
				@toggleServiceDate="toggleService" 
				:mapType="filter.territoryOptions.mapType" 
				:area="filter.territoryOptions.area"
				:dataMarket="data.territoryMarket" 
				:dataMarketDocs="data.territoryMarketDocument" 
				:dataMarketDealer="data.territoryMarketDealer" 
				:data="data[sendData]"
				:type="sendData"
				:toggleService="toggleServiceDate"
				ref="territoryManagement"
				:trendSales="trendSales"
			/>

			
		</div>
		<!-- Teritory Management End-->
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import TerittoryManagement from './../children/TerritoryManagement/MapLoad'
import listUrl from './../listUrl.js'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
// const XLSX = require('xlsx')
const XLSX = require('xlsx')

export default {
	props: ['options' , 'period', 'mobile', 'data' , 'filter', 'rangeOption' , 'typeMap' , 'trendSales'],
	components: {
		Multiselect,
		TerittoryManagement,
		DateRangePicker
	},
	data () {
		return {
			optionRangeTerritory : 'Semester',
			territoryRange : {
				startDate : this.filter.territoryOptions.start,
				endDate : this.filter.territoryOptions.end,
			},
			territoryRangeService : {
				startDate : this.filter.territoryOptions.start_service,
				endDate : this.filter.territoryOptions.end_service,
			},
			territoryRangeService2 : {
				startDate : this.filter.territoryOptions.start_service_2,
				endDate : this.filter.territoryOptions.end_service_2,
			},
			filterByMaster : [{
				name : 'SSU Date',
				variable : 'ssu_date'
			}, {
				name : 'Scan Date',
				variable : 'scan_date'
			}],
			labelTerritory : '',
			labelTerritoryService : '',
			labelTerritoryService2 : '',
			moment : moment,
			type : 'Sales',
			sendData : 'territory',
			reload : true,
			totalCount : null,
			toggleServiceDate : true
		}
	},
	watch : {
		type : function () {
			this.sendData = null
			this.filter.territoryOptions.includeServiceDate = true

			if(this.type == 'Sales') this.sendData = 'territory'
			else if (this.type == 'Service') {
				this.toggleServiceDate = true
				this.sendData = 'territoryService'
			} 
			else this.sendData = 'territorySalesByDocument'
		},
		territoryRange : function() {
			this.filter.territoryOptions.start = new moment(this.territoryRange.startDate).format('Y-MM-DD')
			this.filter.territoryOptions.end = new moment(this.territoryRange.endDate).format('Y-MM-DD')

			let start =  new moment(this.territoryRange.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeTerritory == 'Semester')
				this.labelTerritory = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeTerritory == 'Quarterly')
				this.labelTerritory = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelTerritory = `Custom`

		},
		territoryRangeService : function() {
			this.filter.territoryOptions.start_service = new moment(this.territoryRangeService.startDate).format('Y-MM-DD')
			this.filter.territoryOptions.end_service = new moment(this.territoryRangeService.endDate).format('Y-MM-DD')

			let start =  new moment(this.territoryRangeService.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeTerritory == 'Semester')
				this.labelTerritoryService = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeTerritory == 'Quarterly')
				this.labelTerritoryService = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelTerritoryService = `Custom`

		},
		territoryRangeService2 : function() {
			this.filter.territoryOptions.start_service_2 = new moment(this.territoryRangeService2.startDate).format('Y-MM-DD')
			this.filter.territoryOptions.end_service_2 = new moment(this.territoryRangeService2.endDate).format('Y-MM-DD')

			let start =  new moment(this.territoryRangeService2.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeTerritory == 'Semester')
				this.labelTerritoryService2 = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeTerritory == 'Quarterly')
				this.labelTerritoryService2 = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelTerritoryService2 = `Custom`

		},
		// 'filter.territoryOptions' : {
		// 	deep : true,
		// 	handler() {
		// 		let url = listUrl.stringUrl.territoryManagement.territoryManagement
		// 		let params = listUrl.param.territoryManagement.territoryManagement

		// 		this.$emit('loadAPI' , url , params )
			
		// 	}
		// }
	},
	mounted () {
		// console.log(this.filter.territoryOptions)
		this.$emit('search')

		
	},
	methods : {
		downloadSuggestRing () {
			if(!this.filter.territoryOptions.dealer) return
			this.$http.get('/api/highlight/territory-management/suggest-ring?dealer=' + this.filter.territoryOptions.dealer.code)
			.then((resp) => {
				let wb = XLSX.utils.book_new()
				let ws = XLSX.utils.json_to_sheet(resp.data.data, {raw: true})
				XLSX.utils.book_append_sheet(wb, ws, "Data")
				XLSX.writeFile(wb, `Suggest Ring ${this.filter.territoryOptions.dealer.code}.xls`)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		async downloadExcel () {
			if(this.sendData == 'territorySalesByDocument') {
				try {
					let filterData = await this.transformFilter(this.filter.territoryOptions)
					let url = this.initialiseFilter('/api/highlight/territory-management/download-sales-by-document?' , filterData)

                    let response = await this.$http.get(url)

					let data = response.data.data

					let wb = XLSX.utils.book_new()
					let ws = XLSX.utils.json_to_sheet(data, {raw: true})
					XLSX.utils.book_append_sheet(wb, ws, "Data")
					XLSX.writeFile(wb, `Territory Sales By Document.xls`)
                }
                catch(err) {
                    console.log(err)
                }
			}
			else {
				this.$refs.territoryManagement.download()
			}	
		},
		hitAPI () {
			let url = listUrl.stringUrl.territoryManagement.territoryManagement
			let params = listUrl.param.territoryManagement.territoryManagement

			this.$emit('loadAPI' , url , params )
		},
		toggleService(data) {
			this.toggleServiceDate = data
			this.filter.territoryOptions.includeServiceDate = data
			console.log(this.filter.territoryOptions)
			// let url = listUrl.stringUrl.territoryManagement.territoryManagement
			// let params = listUrl.param.territoryManagement.territoryManagement

			// this.$emit('loadAPI' , url , params )
			// console.log("emited")
		},
		changeDoc (data) {
			this.type = data
		},
		showTotal(data) {
			this.totalCount = data
		},
		async exportExcel() {
			if(!this.data || !this.data.territory) {
				// this.$store.dispatch('triggerAlert' , [false , 'Territoy Data Not Ready. Please Try Again Later.'])
				alert('Territory Data Not Ready. Please Try Again Later.')
				return;
			}


			let exportFileName = 'Territory Data.xls'
			// let wb = XLSX.utils.book_new()
			// let ws = XLSX.utils.json_to_sheet(this.data[data], {raw: true})
			// XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
			// XLSX.writeFile(wb, exportFileName)


			let wb = XLSX.utils.book_new()

			let newData = this.data.territory.points

			let fields = [{
				variable : 'engine_no',
				name : 'Engine Number'
			}, {
				variable : 'type',
				name : 'Vehicle Type'
			}, {
				variable : 'purchase_dealer',
				name : 'Dealer Code'
			}, {
				variable : 'lat',
				name : 'Lat'
			}, {
				variable : 'lng',
				name : 'Lng'
			}]

			

			let newObj = await this.filterData(newData, fields)
			// console.log(newObj)

			var ws = XLSX.utils.json_to_sheet(newObj, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws,'Data')

			XLSX.writeFile(wb, exportFileName)
		},
		filterData (newData , fields) {
			let newObj = []
			for(var i = 0 ; i < newData.length ; i++) {
				
				let obj = {}
				for(var j = 0 ; j < fields.length ; j++) {
					obj[fields[j].name] = newData[i][fields[j].variable]
				}
				// console.log(obj)
				newObj.push(obj)
			}
			return newObj
		}
	}
}
</script>

<style scoped>
	.highlightFilter {
		padding-top : 0;
		padding-bottom : 0;
	}

	.row {
		padding: 0;
	}
</style>

<style scoped>
	.h3title{
		margin: 0 0 8px 0;
		font-weight:600;
		line-height:1.2;
		font-size: x-large;
		display:block;
		margin-inline-start: 0;
		margin-inline-end: 0;
		color:#707070;
	}

	.btn-primary {
		background-color: #FF9700;
		border-color: #FF9700;
	}

	.btn-outline-primary {
		border-color: #FF9700;
		color: #FF9700;
	}

	.btn-outline-primary:hover {
		background-color: #FF9700;
		color: white;
	}

	.btn-outline-primary:focus {
		background-color:#FF9700;
	}
</style>